(() => {
  if (window.maisonTrackUpsellAdd) return;

  // Called once after cart/add succeeds, never from a click or cart refresh.
  window.maisonTrackUpsellAdd = placement => {
    const events = {
      pdp: { tracking_id: '2f0e', event_target: 'added_through_upsell' },
      cart: { tracking_id: '8e48', event_target: 'added_through_cart_upsell' }
    };
    const payload = events[placement];
    const analytics = window.Shopify?.analytics;
    if (!payload || typeof analytics?.publish !== 'function') return;
    try {
      // Analytics must never block an otherwise successful purchase action.
      Promise.resolve(analytics.publish('eab:custom_event', payload)).catch(() => {});
    } catch (_) {}
  };
})();
